// The cutover button, handed down rather than laid over.
//
// `src/clientSwitch.tsx` builds the button and provides it here; each client
// reads it and renders it inside its own tree. Under `src/client/` and inside
// neither half, because both halves import it and neither may import the
// other. `null` is "no button": a visitor without the dev
// tools, or a client mounted without the switch (a story, a test).

import { createContext, useContext, type ReactNode } from "react";

export const ClientSwitchContext = createContext<ReactNode>(null);

/** The cutover button to render, or `null` where there is none. */
export function useClientSwitchButton(): ReactNode {
  return useContext(ClientSwitchContext);
}
